import React from 'react';
import { Mountain, Wifi, PawPrint, Calendar, ExternalLink } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { cabinRentals } from '../mock';

const CabinRentals = () => {
  return (
    <section id="cabin-rentals" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="bg-amber-100 text-amber-900 px-4 py-2 rounded-full text-sm font-semibold">
                Vacation Rentals
              </span>
            </div>
            
            {/* Cabin Rentals Logo */}
            <div className="mb-4">
              <img 
                src={cabinRentals.logo} 
                alt={cabinRentals.title}
                className="h-32 w-auto"
              />
            </div>
            
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
              {cabinRentals.title}
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {cabinRentals.description}
            </p>

            <div className="grid grid-cols-2 gap-4 pt-4">
              {[
                { icon: Mountain, text: 'Mountain Views' },
                { icon: Wifi, text: 'Modern Amenities' },
                { icon: PawPrint, text: 'Pet-Friendly' },
                { icon: Calendar, text: 'Easy Booking' }
              ].map((feature, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                    <feature.icon className="w-5 h-5 text-amber-800" />
                  </div>
                  <span className="text-gray-700 font-medium">{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <Button 
                onClick={() => window.open(cabinRentals.link, '_blank')}
                size="lg"
                className="bg-amber-800 hover:bg-amber-900 text-white transition-colors"
              >
                Book Your Stay
                <ExternalLink className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/i3iwlpcg_IMG_1770.jpeg" 
                alt="Greenwood Hill Cabin"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CabinRentals;
